export default "947acdc5b8feae63.svg"